import {
  Button,
  Dialog,
  Backdrop,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteEffortContactDialogProps = {
  open: boolean;
  effortContactId: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteEffortContactDialog = ({
  open,
  effortContactId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteEffortContactDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await apiService.deleteEffortContact(Number(effortContactId));

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="effortContacts.deleteEffortContactCompleted"
            defaultMessage="Seçili Efor Muhatabını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="effortContacts.deleteEffortContact" defaultMessage="Efor Muhatabı Sil" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          <FormattedMessage
            id="effortContacts.deleteEffortContactRepeat"
            defaultMessage="Bu işlem onaylandıktan sonra Efor Muhatabı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button variant="contained" type="button" onClick={handleDelete}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
      <Backdrop
        sx={{ display: 'flex', flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <img src={loaderLogoSrc} alt="loader-logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default DeleteEffortContactDialog;
